/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_0_QuestionInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_0_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_0_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does GridCraft run Excel VBA macros?`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_0_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_0_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 能运行 Excel 的 VBA 宏吗？`)
};

/**
* | output |
* | --- |
* | "Does GridCraft run Excel VBA macros?" |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_0_QuestionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_0_question = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_0_QuestionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_0_QuestionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_0_question(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_0_question(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_0_question as "gc.search_guides.gridcraft_excel_compatibility.sections.8.questions.0.question" }